import { useState, useCallback } from "react";
import { startChatAndGenerateSolution, continueChat } from "../services/geminiService";

export const useAiChat = (currentProblem, selectedAnswerText) => {
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [chatHistory, setChatHistory] = useState([]);
    const [isResponding, setIsResponding] = useState(false);

    // --- 1. Otwieranie czatu (Start Session) ---
    const handleOpenChat = useCallback(async () => {
        setIsChatOpen(true);

        if (chatHistory.length === 0) {
            setIsResponding(true);
            try {
                if (!currentProblem) throw new Error("Brak danych zadania do rozpoczęcia czatu.");

                // Sprawdzenie ID dla pewności
                const problemId = currentProblem.problem_id || currentProblem.id;
                if (!problemId) console.warn("Ostrzeżenie: Brak ID problemu przy otwieraniu czatu AI");

                // Wywołujemy funkcję z nowym argumentem problemId
                const { updatedHistory } = await startChatAndGenerateSolution(
                    currentProblem.question,
                    selectedAnswerText,
                    currentProblem.true_answer,
                    currentProblem.points_assigned,
                    problemId // <--- TUTAJ DODAŁEM ID
                );
                setChatHistory(updatedHistory);
            } catch (err) {
                console.error("Błąd otwierania czatu AI:", err);
                setChatHistory([{ role: 'model', parts: [{ text: `Przepraszam, wystąpił błąd: ${err.message}` }] }]);
            } finally {
                setIsResponding(false);
            }
        }
    }, [chatHistory.length, currentProblem, selectedAnswerText]);

    // --- 2. Wysyłanie wiadomości (Continue Session) ---
    const handleSendMessage = useCallback(async (msg) => {
        // Optymistyczna aktualizacja UI (dodajemy wiadomość usera od razu)
        const historyBeforeSend = [...chatHistory, { role: "user", parts: [{ text: msg }] }];
        setChatHistory(historyBeforeSend);
        setIsResponding(true);

        try {
            // Ponowne pobranie ID
            const problemId = currentProblem?.problem_id || currentProblem?.id;

            const { updatedHistory } = await continueChat(
                chatHistory, // Historia BEZ nowej wiadomości (backend sam ją sobie doklei z argumentu msg)
                msg,         // Nowa wiadomość osobno
                currentProblem?.points_assigned || 1,
                problemId    // <--- TUTAJ DODAŁEM ID
            );
            
            setChatHistory(updatedHistory);
        } catch (err) {
            console.error("Błąd kontynuacji czatu AI:", err);
            // W razie błędu dodajemy komunikat do historii widocznej dla usera
            setChatHistory(prev => [...prev, { role: 'model', parts: [{ text: `Wystąpił błąd: ${err.message}` }] }]);
        } finally {
            setIsResponding(false);
        }
    }, [chatHistory, currentProblem]);

    const resetChat = useCallback(() => {
        setChatHistory([]);
        setIsChatOpen(false);
        setIsResponding(false);
    }, []);

    return {
        isChatOpen,
        chatHistory,
        isResponding,
        handleOpenChat,
        handleSendMessage,
        setIsChatOpen,
        resetChat
    };
};